/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* global dataLayer */
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  react/no-find-dom-node,
  react/prop-types
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import CreateAccountForm from './create-account-form';

const CreateAccount = createReactClass({

  propTypes: {
    header: PropTypes.string.isRequired,
    googleSignInClientId: PropTypes.string,
    csrfToken: PropTypes.string,
    isFromApiPricing: PropTypes.bool,
    isInline: PropTypes.bool,
    isVertical: PropTypes.bool, // only for inline
    inlineSideText: PropTypes.string,
    tabOffset: PropTypes.number,
    signupForm: PropTypes.object.isRequired, // Serialized sfForm
    signupUrl: PropTypes.string,
    redirectUrl: PropTypes.string,
    recoverPasswordForm: PropTypes.object, // Serialized sfForm
    loginForm: PropTypes.object, // Serialized sfForm
    hideRememberMe: PropTypes.bool,
    hideGoogleOpenId: PropTypes.bool,
    async: PropTypes.bool,
    dropboxSSO: PropTypes.bool,
    // URLs displayed to the user as links for Terms/Privacy Policy
    tosUrl: PropTypes.string.isRequired,
    privacyPolicyUrl: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      signupUrl: '/account/signUp',
    };
  },

  getInitialState() {
    return {
      password: '',
      emailAddress: '',
      isProcessing: false,
      isInline: false,
      isVertical: false,
    };
  },

  componentDidMount() {
    if (!this.props.isInline && process.env.NODE_ENV !== 'test') {
      $(document).foundation();
      $(ReactDOM.findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    }

    this.reportAnalytics();
  },

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isInline && process.env.NODE_ENV !== 'test') {
      $(ReactDOM.findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    }
  },

  reportAnalytics() {
    // Abort false triggers for when the component is mounted with no values on its props
    if (!this.props.planName || !this.props.period) {
      return;
    }

    dataLayer.push({
      event: 'modal_popup',
      pageName: '/account/signUp',
      pageType: 'accountSignUp',
      virtualPagePath: '/account/signUp',
      productPlan: this.props.planName.toLowerCase(),
      productType: this.props.isApi ? 'hsapi' : 'hs',
      subscriptionPlan: this.props.period.toLowerCase(),
    });
  },

  render() {
    return (
      <div>
        <CreateAccountForm
          header={this.props.header}
          tosUrl={this.props.tosUrl}
          privacyPolicyUrl={this.props.privacyPolicyUrl}
          buttonText={this.props.buttonText}
          isInline={this.props.isInline}
          isVertical={this.props.isVertical}
          inlineSideText={this.props.inlineSideText}
          csrfToken={this.props.csrfToken}
          googleSignInClientId={this.props.googleSignInClientId}
          dropboxSSO={this.props.dropboxSSO}
          redirectUrl={this.props.redirectUrl}
          isFromApiPricing={this.props.isFromApiPricing}
          planId={this.props.planId}
          isApi={this.props.isApi}
          planName={this.props.planName}
          skipCC={this.props.skipCC}
          period={this.props.period}
          trialPeriod={this.props.trialPeriod}
          tabOffset={this.props.tabOffset}
          fields={this.props.signupForm.fields}
          values={this.props.signupForm.values}
          namespace={this.props.signupForm.namespace}
          action={this.props.signupUrl}
          recoverPasswordForm={this.props.recoverPasswordForm}
          loginForm={this.props.loginForm}
          hideRememberMe={this.props.hideRememberMe}
          hideGoogleOpenId={this.props.hideGoogleOpenId}
          async={this.props.async} />
      </div>
    );
  },
});

module.exports = CreateAccount;
